<template>
  <v-dialog width="800px" v-model="dialog">
    <template #activator="{ on: dialog }">
      <v-tooltip bottom open-delay="500" color="#5774E7">
        <template #activator="{ on: tooltip, attrs }">
             <div v-on="tooltip">
      <v-btn class="mx-1 pa-2 btn" :disabled="disableSaveButton" v-on="dialog" v-bind="attrs" elevation="0" height="32px" width="32px" x-small color="white" @click="openDialog"><v-icon color="#5774E7" v-text="'mdi-content-save'"></v-icon> </v-btn>
              </div>
              </template>
        <span>Manage your portfolio saves at the start of the simulation</span>

      </v-tooltip>

    </template>
    <v-card>
      <v-card-title class="pl-4">
        <h3>Manage your portfolio saves</h3>
      </v-card-title>
      <v-list outlined mandatory height="300px" class="ma-0 pa-0 overflow-y-auto">
        <v-progress-linear v-if="mainLoading" indeterminate color="teal darken-2" height="5px"></v-progress-linear>
        <v-list-item-group v-else mandatory v-model="model" active-class="border" color="indigo">
          <v-list-item @click="newSaveClick()">
            <v-list-item-icon>
              <v-icon v-text="'mdi-content-save'"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'New Save ...'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="divider"></v-divider>
          <v-list-item v-for="(item, i) in items" :key="i" @click="menuActionClick(i, item)">
            <v-list-item-icon>
              <v-icon v-text="'mdi-cloud-upload'"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="item.saveName"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn @click="deleteItemEvent(i, item)" icon>
                <v-icon color="blue darken-4">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>

        </v-list-item-group>
        <v-spacer></v-spacer>

      </v-list>

      <v-card-actions class="px-5">
        <v-btn width="100px" @click="cancelButton"> Cancel </v-btn>

        <v-text-field label="Save name" class="pl-15 pr-5" v-model="savename" :disabled="this.model!=0"></v-text-field>
        <v-btn width="100px" :disabled="this.savename == ''" @click="pressedSave()">
          {{ this.saveLabel }}
        </v-btn>
        <v-btn width="100px" :disabled="0 == this.model" @click="pressedLoad()"> Load </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>Delete</v-card-title>
        <v-card-text>Are you sure that you want to delete "{{ this.itemNameToDelete }}"</v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="dialogDelete = false">Close</v-btn>
          <v-btn color="primary" text @click="deleteItem()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogUpdate" max-width="500px">
      <v-card>
        <v-card-title>Update</v-card-title>
        <v-card-text>Are you sure that you want to update "{{ this.savename }}"</v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="dialogUpdate = false">Close</v-btn>
          <v-btn color="primary" text @click="save()">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
export default {
  mounted() {
    this.$store.state.portfolioSaveComponent = this;

    this.$nextTick(() => {
      this.disableSaveButton = this.$store.state.simulator.hoursPassed != 0;
    });
  },
  methods: {
    async pressedSave() {
      if(this.model ==0){
        this.save();
      }
      else{
        this.dialogUpdate = true;
      }

    },
    async save(){
      await this.$store.state.networkHandler.storePortfolioSettings(this.savename, this.model > 0);
      await this.requestSettings(false);

      this.dialogUpdate = false;
    },
    pressedLoad() {
        var result = this.items.find(save => {
            return save.saveName === this.savename;
        })

        var projectVisuals = this.$store.state.visualiser.projectVisuals;
        var newProjectVisuals = [];

        for(var i = 0; i < projectVisuals.length; i++){
            var currProjectVisual = projectVisuals.find(projVis => {return projVis.project.projectIndex === result.projectOrder[i]});
            newProjectVisuals.push(currProjectVisual)
            currProjectVisual.project.updateStartHour(result.startHours[i], true);
        }

        this.$store.state.visualiser.projectVisuals = newProjectVisuals;
        this.$store.state.visualiser.sortProjects(false, 5);
        this.$store.state.visualiser.updateElements(250);
        this.$store.state.futureLoadGraph.updateData(true);

    },
    newSaveClick() {
      this.savename = "";
      this.saveLabel = "Save";
    },
    deleteItemEvent(index, item) {
      this.indexToDelete = index;
      this.itemNameToDelete = item.saveName;

      this.dialogDelete = true;
    },

    menuActionClick(index, item) {
      this.savename = item.saveName;
      this.saveLabel = "Update";
    },
    cancelButton() {
      
      this.dialog = false;
    },
    async deleteItem() {
      await this.$store.state.networkHandler.deletePortfolioSettings(this.itemNameToDelete);
      await this.requestSettings(false);
      this.dialogDelete = false;

    },

    async requestSettings(useLoading = true){
        if(useLoading){
            this.mainLoading = true;
        }

        var data = await this.$store.state.networkHandler.getAllPortfolioSettings();
       this.items = data;
       this.mainLoading = false;

        this.model = 0;
        this.newSaveClick();
       
    },

    async openDialog() {
        await this.requestSettings();
        this.newSaveClick();

    },
  },
  data: () => ({
    dialog: false,
    savename: "",
    saveLabel: "Save",
    dialogDelete: false,
    dialogUpdate: false,
    itemNameToDelete: "",
    indexToDelete: 0,

    mainLoading: true,
    disableSaveButton: true,

    items: [],
    model: 0,
  }),
};
</script>

<style scoped>
.divider {
       border-width: 1px !important;
       border-color: rgba(55, 55, 55, 0.3) !important;
       height: 100%;
}

.btn {
  border: 1px solid #abb8f8 !important;
}

.btn {
  height: var(--simulation-button-height);
  width: var(--simulation-button-height);

  border: none;
  border-radius: 20%;
  background-color: var(--background-color);
}
</style>

<style scoped>
::-webkit-scrollbar {
  width: 10px;
}
</style>
